module.exports = __webpack_public_path__ + "static/ulogo-63cb3382d8f4e4de2737236ac50d5ba7.jpg";